import { render, staticRenderFns } from "./DatepickerWrap.vue?vue&type=template&id=0c04db8d"
import script from "./DatepickerWrap.vue?vue&type=script&lang=js"
export * from "./DatepickerWrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports